import request from '@/utils/request'

// 查询裁床成本分析报表列表
export function apiCuttingBedCostAnalysisList (params) {
  return request({
    url: '/mes/cuttingBedCostAnalysisReport/list',
    method: 'get',
    params
  })
}

// 导出裁床成本分析报表
export function apiCuttingBedCostAnalysisExport (data) {
  return request({
    url: '/mes/cuttingBedCostAnalysisReport/export',
    method: 'post',
    data
  })
}
